<template>
  <el-drawer
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :append-to-body="true"
  :title="title"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <ProductDetailInfo :height="height" :product="selectedProduct" :editItem="false" @editItem="v => $emit('editItem', v)"></ProductDetailInfo>
  </div>
</el-drawer>
</template>
<script>
import ProductDetailInfo from './product-detail-info'
import InventoryProductTitle from './inventory-product-title'
import { mapActions, mapState, mapGetters } from 'vuex';
import ProductUtil from '@/utils/product-util'
export default {
  name: 'product-detail-drawer',
	props: {
    puid : {type : String},
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },components: {
    ProductDetailInfo,
    InventoryProductTitle,
  },
  watch : {

  },
	methods: {
    open(){
      this.fetchSelectedProduct(this.puid);
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('inventoryProducts', ['fetchSelectedProduct'])
	},
	computed: {
    title () {
      return ProductUtil.getExtendedProductName(this.selectedProduct);
    },
    productName(){
      if(this.selectedProduct==null) return "";
      else return this.selectedProduct.name;
    },
    height(){
      return this.window.height-130
    },
    divHeight(){
      return "height :"+this.height + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "70%";
      }else{
        return "100%"
      }
    },
    ...mapState('inventoryProducts',['selectedProduct'])

	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:20px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
